export default interface UserSetting {
  userId: number;
  controlName: string;
  type: string;
  userSetting: string;
  profileName: string;
  isDefault: boolean;
  modDate: Date;
  modTime: Date;
  modUser: number;
}

export const UserSettingDefaultProps: UserSetting = {
  userId: 0,
  controlName: "",
  type: "",
  userSetting: "",
  profileName: "",
  isDefault: false,
  modDate: new Date(),
  modTime: new Date(),
  modUser: 0,
};
